module.exports = __webpack_public_path__ + "img/dec14_05.d5614d32.jpeg";